<template>
  <div
    :class="[
      'overflow-hidden bg-white dark:bg-dark-surface-2 dark:border dark:border-dark-border rounded-[12px_12px_12px_4px]',
      sizeClass,
      shadowClass
    ]"
  >
    <img
      :src="src"
      :alt="alt"
      class="w-full h-full object-cover"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  alt: {
    type: String,
    required: true,
  },
  size: {
    type: Number,
    default: 12,
    validator: (value) => {
      // Allow common Tailwind size values
      const validSizes = [8, 10, 12, 16, 20, 24]
      return validSizes.includes(value)
    }
  },
  shadow: {
    type: String,
    default: 'lg',
    validator: (value) => {
      const validShadows = ['sm', 'md', 'lg', 'xl', 'none']
      return validShadows.includes(value)
    }
  }
})

const sizeClass = computed(() => {
  return `w-${props.size} h-${props.size}`
})


const shadowClass = computed(() => {
  if (props.shadow === 'none') {
    return ''
  }
  return `shadow-${props.shadow}`
})
</script>
